module.exports = __webpack_public_path__ + "img/bg_login.0bca1f78.jpg";